import Card from "../../components/card";

const Widget = (props: {
  icon: JSX.Element;
  title: string;
  subtitle: string;
}) => {
  const { icon, title, subtitle } = props;
  return (
    <Card extra="!flex-row flex-grow items-center rounded-[20px] p-1">
      <div className="ml-3 flex h-[90px] w-auto flex-row items-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-dv-cyan-500 text-white shadow-lg shadow-brand-500/25">
          <span className="flex items-center">{icon}</span>
        </div>
      </div>

      <div className="ml-4 flex w-auto flex-col justify-center">
        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{title}</p>
        <h4 className="text-xl font-bold tabular-nums text-navy-700 dark:text-white">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
